import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, BookOpen, CreditCard, Package,
  Headphones, Bell, Settings, LogOut, ChevronLeft, ChevronRight, Milk,
} from 'lucide-react';
import '../../assets/styles/customer/layout/CustomerMasterLayout.css';

const NAV_ITEMS = [
  { key: 'dashboard',     label: 'Dashboard',         Icon: LayoutDashboard, path: '/customer/dashboard'     },
  { key: 'dairy',         label: 'My Dairy',           Icon: BookOpen,        path: '/customer/dairy'         },
  { key: 'billing',       label: 'Billing & Payments', Icon: CreditCard,      path: '/customer/billing'       },
  // { key: 'subscription',  label: 'Subscription',       Icon: Package,         path: '/customer/subscription'  },
  { key: 'support',       label: 'Support',            Icon: Headphones,      path: '/customer/support'       },
  { key: 'notifications', label: 'Notifications',      Icon: Bell,            path: '/customer/notifications', badge: 3 },
  { key: 'settings',      label: 'Settings',           Icon: Settings,        path: '/customer/settings'      },
];

const CustomerMasterLayout = ({ children }) => {
  const navigate   = useNavigate();
  const location   = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const isActive = (path) => location.pathname === path;

   const [isLoading, setIsLoading] = useState(false);
  


  return (
    <div className={`cml-root${collapsed ? ' cml-root--collapsed' : ''}`}>

      {/* ══ SIDEBAR ══ */}
      <aside className="cml-sidebar">

        {/* Logo */}
        
        <div className="cml-logo">
          {collapsed ? <ChevronLeft size={13} /> : <>
          <div className="cml-logo__icon"><Milk size={19} /></div>
          <span className="cml-logo__text">Customer</span>
          </>
        }
        </div>

        {/* Collapse toggle */}
        <button
          className="cml-collapse-btn"
          onClick={() => setCollapsed(c => !c)}
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? <ChevronRight size={13} /> : <ChevronLeft size={13} />}
        </button>

        {/* Nav label */}
        {!collapsed && <p className="cml-nav-label">MENU</p>}

        {/* Nav items */}
        <nav className="cml-nav">
          {NAV_ITEMS.map(({ key, label, Icon, path, badge }) => (
            <button
              key={key}
              className={`cml-nav-item${isActive(path) ? ' cml-nav-item--active' : ''}`}
              onClick={() => navigate(path)}
              title={collapsed ? label : undefined}
            >
              <span className="cml-nav-item__icon-wrap">
                <Icon size={17} strokeWidth={1.8} />
                {badge > 0 && !isActive(path) && (
                  <span className="cml-nav-item__badge">{badge}</span>
                )}
              </span>
              {!collapsed && <span className="cml-nav-item__label">{label}</span>}
            </button>
          ))}
          <button
            className="cml-logout-btn mt-4"
            disabled={isLoading}
            onClick={() => navigate('/login')}
            title={collapsed ? 'Log Out' : undefined}
          >

 {isLoading ? (
                    <span className="admin-login-loading">
                      <span className="admin-login-spinner"></span>
                      logging In...
                    </span>
                  ) : (
                    'Login In'
                  )}
            <LogOut size={17} strokeWidth={1.8} />
            {!collapsed && <span>Log Out</span>}
          </button>
        </nav>

        {/* Logout — pinned bottom */}
        {/* <div className="cml-sidebar__bottom">
          <button
            className="cml-logout-btn"
            onClick={() => navigate('/login')}
            title={collapsed ? 'Log Out' : undefined}
          >
            <LogOut size={17} strokeWidth={1.8} />
            {!collapsed && <span>Log Out</span>}
          </button>
        </div> */}

      </aside>

      {/* ══ MAIN ══ */}
      <main className="cml-main">
        <div className="cml-content">{children}</div>
      </main>

    </div>
  );
};

export default CustomerMasterLayout;